import React, { ChangeEvent, Component } from "react";
import DynamicListView from "../CommonComponentListView/DynamicListView";
import Service from "../../../services";
import { AxiosError, AxiosResponse } from "axios";
import { productDataModel } from "../../../models/ProductsModel";
import "./productsTab.scss";
import { Container, Modal } from "reactstrap";
import ModalComponent from "../../shared/ModalComponent";
import EditProductForm from "./EditProductForm";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import { ColumnConfig } from "../../../models/ActionModel";
import { catchError } from "../../../utils/Utils";
import { toast } from "react-toastify";
import { transformDateWithDash } from "../../../utils/dateUtil";
import serachIcon from "../../../images/magnifying-glass-svg.svg";
import { BankUserContext } from "../../../bankUserContext";
import FinSpinner from "../../../commonfields/FinSpinner";
import { withContext } from "../../Authentication/RoleAuthorizationClassComponent";
import { Pages, actionAuthorization } from "../../../utils/RolesUtil";
import { WithContextProps } from "../../shared/WithContext";
import { redirect } from "react-router";
import { set } from "lodash";
// import { TriggerContext } from "../../../Context/TriggerContext";

interface initialProps {
  refreshComponent: boolean;
  context:any;
  triggerContext:any;
}

interface options {
  id: string;
  text: string;
  value: string;
}

interface productsState {
  productsData: productDataModel[] | [];
  columnNames: ColumnConfig[];
  showModal: boolean;
  initialValues: object;
  productsDataOptions: options[];
  selectedProductDetails: productDataModel | null;
  serachValue: string;
  loader: boolean;
}

type CombinedProps = WithRouterProps<initialProps> & WithContextProps<unknown>;

class ProductsMainCC extends Component<
  CombinedProps,
  productsState
> {
  service: Service;
  static contextType = BankUserContext;
  // static triggerContext = TriggerContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  // triggerContext: React.ContextType<typeof TriggerContext> | undefined;
  constructor(props: any) {
    super(props);
    this.state = {
      productsData: [],
      columnNames: [
        {
          label: "account",
          columnStyling: "productContainer",
          textStyling: "productName",
          displayText: 5,
          orderId: 1,
        },
        {
          label: "estimatedvalue",
          displayText: 1,
          columnStyling: "subGroup",
          orderId: 2,
          displayLabelText: "Est Value",
        },
        {
          label: "expectedclosedate",
          displayText: 1,
          columnStyling: "subGroup",
          orderId: 3,
          displayLabelText: "expected close",
        },
        {
          label: "percentagetosale",
          displayText: 1,
          columnStyling: "subGroup",
          orderId: 4,
          displayLabelText: "percent to sale",
        },
        {
          label: "status",
          displayText: 3,
          columnStyling: "productStatusContainer",
          textStyling: "",
          condition: this.statusClassDefining,
          orderId: 5,
        },
      ],
      showModal: false,
      initialValues: {},
      productsDataOptions: [],
      selectedProductDetails: null,
      serachValue: "",
      loader: false,
    };
    this.service = new Service();
  }

  clientId = this.props.params.clientId;
  componentDidMount() {
    this.getProducts();
    this.getDropDownsData();
  }

  componentDidUpdate(
    prevProps: Readonly<WithRouterProps<initialProps>>,
    prevState: Readonly<productsState>,
    snapshot?: any
  ): void {
    if (prevProps.refreshComponent !== this.props.refreshComponent) {
      this.getProducts();
      this.getDropDownsData();
    }
  }
  getProducts = (search?: string) => {
    let data: {
      screen: string;
      sections: string;
      clientId: string;
      isJsonReturnObject: boolean;
      search?: string;
    } = {
      screen: "ProspectDetails",
      sections: "GetClientProducts",
      clientId: "",
      isJsonReturnObject: false,
    };

    if (this.clientId) {
      data = { ...data, clientId: this.clientId };
    }

    if (search) {
      data.search = search;
    }
    this.service
      .getProductsData(data)
      .then((response: AxiosResponse<productDataModel[]>) => {
        // console.log(response.data)

        this.setState({ productsData: response.data });
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  statusClassDefining = (value: string) => {
    switch (value) {
      case "Active":
        return "active";
      case "Inprogress":
        return "inprogress";
      default:
        return "emptyData";
    }
  };

  editProduct = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  editProducItemModal = (tileValues: productDataModel) => {
    const initialValues = {
      product: tileValues.productid,
      estimatedValue: tileValues.estimatedvalue,
      percentageToSale: tileValues.percentagetosale,
      expectedClose: tileValues.expectedclosedate,
    };
    this.setState({
      initialValues: initialValues,
      selectedProductDetails: tileValues,
    });
    this.editProduct();
  };

  getDropDownsData = () => {
    const dropDownData = {
      screen: "ProspectsTR",
      sections: "productDropDownList",
      isJsonReturnObject: true,
      orgId: this.context?.bankuserDetails?.organization.orgId,
      roleId: this.context?.bankRolesData?.roleId,
    };
    this.setState({ loader: true });
    this.service
      .getDropDownData(dropDownData)
      .then((response: AxiosResponse<any>) => {
        if (response.data) {
          const productsDataOptions = response.data[0].productname?.map(
            (m: any) => {
              return {
                id: m.id,
                text: m.text,
                value: m.id,
              };
            }
          );
          this.setState({
            productsDataOptions: productsDataOptions,
          });
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  };
   
  editProductForm = (values: any) => {
    this.setState({ loader: true });
    const formData = {
      sections: "CreateClientProduct",
      data: {
        clientProductId: this.state.selectedProductDetails?.clientproductid,
        productId: values?.product,
        clientId: this.state.selectedProductDetails?.clientid,
        assignTo: this.state.selectedProductDetails?.assignTo,
        estimatedValue: values?.estimatedValue == "" ? null : values?.estimatedValue,
        expectedCloseDate: values?.expectedClose == "" ? null : transformDateWithDash(values?.expectedClose),
        percentageToSale: values?.percentageToSale,
        account: this.state.selectedProductDetails?.account,
        clientProductStatus: this.state.selectedProductDetails?.status,
        createdDate: this.state.selectedProductDetails?.createdDate,
        updatedDate: new Date(),
      },
    };


    this.service
      .editProducts(formData)
      .then(() => {
        toast.success("Product Edited Successfully..!!");
        this.getProducts();
        this.getDropDownsData();
        if((this.state?.initialValues as any)?.product !== values?.product){
          setTimeout(() => {
            window.location.reload();
    
            },100)
            this.setState({ loader: true });
        }
        
      })
      
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
    this.editProduct();
  };

  handleSearchItem = (event: ChangeEvent<HTMLInputElement>) => {
    this.getProducts(event.target.value);
    this.setState({ serachValue: event.target.value });
  };

  render() {
    return (
      <>
        {this.state.loader && <FinSpinner />}
        <div className="productsContainer">
          <div className="productsSearchComponent">
            <input
              type="search"
              onChange={this.handleSearchItem}
              placeholder={"Search"}
            />
            {!this.state.serachValue && (
              <img src={serachIcon} className="searchIcon" alt="serachIcon" />
            )}
          </div>
          <DynamicListView
            tilesData={this.state.productsData}
            columnNames={this.state.columnNames}
            modalCondtion={this.editProducItemModal}
            className={"productsTile"}
            showMenuItems={withContext(
              this.context,
              Pages.customerDetailsPage,
              actionAuthorization.editProductsTile
            )&& !this.props.context?.readOnlyMode}
          />
          <ModalComponent
            showModal={this.state.showModal}
            modalToggle={this.editProduct}
            className="editProductModal"
            HeaderName={"Edit Product"}
          >
            <Container fluid>
              <div>
                <EditProductForm
                  handleActionItemSave={this.editProductForm}
                  initalData={this.state.initialValues}
                  productsDataOptions={this.state.productsDataOptions}
                  disableProduct={this.state.selectedProductDetails?.editFlag}
                />
              </div>
            </Container>
          </ModalComponent>
        </div>
      </>
    );
  }
}

export default withRouter<WithRouterProps<initialProps>>(ProductsMainCC);
